export enum DeviceOsType {
  andoird = 'android',
  ios = 'ios',
  mac = 'mac',
}
